/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiArchive, ApiArchiveLink } from '@Model';
import type { HttpActions, ListInfo, ListRequest, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ArchivesController.
 */
export class ArchivesRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /archives:query
     */
    public getList(listRequest: ListRequest): Promise<Result<ListInfo<ApiArchive>>> {
        return this.http.post<Result<ListInfo<ApiArchive>>, ListRequest>('/archives:query', listRequest);
    }

    /**
     * Calls GET /archives/{id}
     */
    public describe(id: string): Promise<Result<ApiArchive>> {
        return this.http.get<Result<ApiArchive>>(`/archives/${id}`);
    }

    /**
     * Calls GET /archives/{id}:download
     */
    public download(id: string): Promise<Result<ApiArchiveLink>> {
        return this.http.get<Result<ApiArchiveLink>>(`/archives/${id}:download`);
    }

    /**
     * Calls POST /archives/{id}:rebuild
     */
    public rebuild(id: string): Promise<Result<ApiArchive>> {
        return this.http.post<Result<ApiArchive>, undefined>(`/archives/${id}:rebuild`, undefined);
    }
}
